import { React, PT, withRouter } from '@gasbuddy/react';
import moment from 'moment';
import { Table } from 'semantic-ui-react';

const BaseRequestTable = ({ requests, total, history }) => {
  if (!requests || requests.length === 0) {
    return (<i>There are no requests in the selected time range</i>);
  }
  return (
    <Table basic="very" selectable style={{ tableLayout: 'fixed', fontSize: '0.9em' }}>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={3} textAlign="center">Date</Table.HeaderCell>
          <Table.HeaderCell>URL</Table.HeaderCell>
          <Table.HeaderCell width={2} textAlign="center">Status</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {requests.map(r => (
          <Table.Row key={r.c} onClick={() => history.push(`/system/logs/correlationId/${encodeURIComponent(r.index)}/${encodeURIComponent(r.c)}`)}>
            <Table.Cell textAlign="center" style={{ paddingLeft: '3px' }}>{moment(r.ts).fromNow(true)}</Table.Cell>
            <Table.Cell style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>{`${r.m.toUpperCase()} ${r.label}${r.url}`}</Table.Cell>
            <Table.Cell textAlign="center">{r.s}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
      {(total > requests.length) && (
        <Table.Footer>
          <Table.Row>
            <Table.Cell colSpan={3} textAlign="right">
              {total}
              {' '}
requests
            </Table.Cell>
          </Table.Row>
        </Table.Footer>
      )}
    </Table>
  );
};

BaseRequestTable.propTypes = {
  requests: PT.arrayOf(PT.shape({
    ts: PT.number.isRequired,
    label: PT.string.isRequired,
    url: PT.string.isRequired,
    s: PT.number.isRequired,
  })),
  total: PT.number,
  history: PT.shape({ push: PT.func.isRequired }).isRequired,
};

BaseRequestTable.defaultProps = {
  requests: null,
  total: 0,
};

export const RequestTable = withRouter(BaseRequestTable);
